import { createContext } from 'react';

import User from 'entities/User';

type AuthContext = {
	isAuth: boolean;
	user: User | null;
	login: (name: string, password: string) => Promise<void>;
	logout: () => Promise<void>;
};

const AuthContext = createContext<AuthContext>(null!);

export default AuthContext;
